import {
    JUST_ASK_QUANTITY_SET,
    JUST_ASK_ADD_STARTED,
    JUST_ASK_ADD_FINISHED,
    JUST_ASK_ADD_FAILED,
    JUST_ASK_UPDATE_STARTED,
    JUST_ASK_UPDATE_FINISHED,
    JUST_ASK_UPDATE_FAILED
} from 'constants/actionTypes';

export const justAskQuantitySet = (transactionTypeId, quantity, orderId) => ({type: JUST_ASK_QUANTITY_SET, transactionTypeId, quantity, orderId});

export const justAskAddStarted = (request, orderId) => ({type: JUST_ASK_ADD_STARTED, request, orderId});
export const justAskAddFinished = (payload, orderId) => ({type: JUST_ASK_ADD_FINISHED, payload, orderId});
export const justAskAddFailed = (payload, orderId) => ({type: JUST_ASK_ADD_FAILED, payload, orderId});

export const justAskUpdateStarted = (request, orderId) => ({type: JUST_ASK_UPDATE_STARTED, request, orderId});
export const justAskUpdateFinished = (payload, orderId) => ({type: JUST_ASK_UPDATE_FINISHED, payload, orderId});
export const justAskUpdateFailed = (payload, orderId) => ({type: JUST_ASK_UPDATE_FAILED, payload, orderId});


// WEBPACK FOOTER //
// ./src/actions/justAskActions.js